/**
 *
 * InfoCard
 *
 */

import React, { useEffect, useState, useCallback } from "react";
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Dropdown } from "antd";

// assets
import { DownOutlined } from "@ant-design/icons";

function LanguageSelector({
  lang,
  // default
  children,
  className,
  ...rest
}) {
  const childClassNames = classNames("tcf-language-selector", className);
  const [t, i18n] = useTranslation();
  const language = localStorage.getItem('i18nextLng') || i18n?.language || process.env.DEFAULT_LANGUAGE || "fr";

  const languages = ["fr", "de", "en"];

  const initLangList = useCallback((langs) => { 
    return langs?.map((lang) => { 
      return { 
        key: lang, 
        label: t(`common.language-selector.languages.${lang}`) 
      }
    }) || [];
  }, []);

  const [open, setOpen] = useState(false);
  const [languageList, setLanguageList] = useState(initLangList(languages) || []);
  const [activeLang, setActiveLang] = useState({
    key: i18n?.language || language,
    label: t(`common.language-selector.languages.${i18n?.language || language}`)
  });

  const chageLanguage = useCallback(
    lang => {
      if (activeLang?.key != lang || activeLang?.key != i18n.language) {
        i18n.changeLanguage((!!lang && lang) || language);
      }
    },
    [i18n.language, activeLang, language],
  );

  useEffect(() => {
    setActiveLang({
      key: i18n?.language || language,
      label: t(
        `common.language-selector.languages.${i18n?.language || language}`,
      ),
    });
  }, [i18n?.language]);
  
  const handleOpenChange = useCallback(flag => {
    setOpen(flag);
  }, []);

  const handleMenuClick = useCallback(
    ({ item, key, keyPath, domEvent }) => {
      chageLanguage(key);
      const newList = initLangList(languages) || [];
      const current = newList?.find(sch => sch?.key == key);
      if (!!current?.key && current?.key != activeLang?.key) {
        setActiveLang(current);
        setLanguageList(initLangList(languages) || []);
        //  window.location.reload();
      }
      setOpen(false);
    },
    [languages, activeLang],
  );

  return (
    <div className={childClassNames}>
      {languageList?.length > 0 ? (
        <Dropdown
          menu={{
            items: languageList,
            onClick: handleMenuClick,
          }}
          trigger={["click"]}
          onOpenChange={handleOpenChange}
          open={open}
          overlayClassName="lang-dropdown-list"
          getPopupContainer={trigger => trigger.parentElement}
        >
          <a className="default" onClick={e => e.preventDefault()}>
            {activeLang?.label || activeLang?.key}
            <DownOutlined />
          </a>
        </Dropdown>
      ) : (
        activeLang?.label || activeLang?.key
      )}
    </div>
  );
}

LanguageSelector.defaultProps = {
  lang: "fr",
};

export default LanguageSelector;
